<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <div class="login">
                <div class="title">
                    <h3 *ngIf="!forg && !mostraReact">Iniciar Sesión</h3>
                    <h3 *ngIf="forg">Recuperar Contraseña</h3>
                    <h3 *ngIf="mostraReact">Solicitar reactivación</h3>
                </div>
                <div class="formul" *ngIf="!forg && !mostraReact">
                    <form action="" [formGroup]="loginForm">
                        <!-- <div class="inp-user">
                            <input class="inputs" type="input" name="user" id="user" formControlName="usuario" required />
                            <label for="user" alt="Usuario" placeholder="Usuario"></label>
                        </div> -->
                        <mat-form-field appearance="outline">
                            <mat-label>Usuario</mat-label>
                            <input matInput class="inputs" type="input" name="user" id="user" formControlName="usuario" #usuario required>
                            <!-- <mat-hint>Hint</mat-hint> -->
                        </mat-form-field>
                        <!-- <div *ngIf="usuario.invalid && (usuario.dirty || usuario.touched)" class="alert alert-danger">
                            <div *ngIf="usuario.errors.required">
                                User is required.
                            </div>
                        </div> -->
                        <!-- <div class="inp-pass">
                            <input class="inputs" type="password" name="pass" id="pass" formControlName="psw" autocomplete="off" required />
                            <label for="pass" alt="Contraseña" placeholder="Contraseña"></label>
                        </div> -->
                        <mat-form-field appearance="outline">
                            <mat-label>Contraseña</mat-label>
                            <input matInput class="inputs" [type]="hidePass ? 'password' : 'text'" name="pass" id="pass" formControlName="psw" autocomplete="off" #psw required>
                            <!-- <mat-hint>Hint</mat-hint> -->
                            <!-- <button mat-icon-button matSuffix (click)="showPass()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePass" class="btn_eye"> -->
                            <mat-icon mat-icon-button matSuffix (click)="showPass()" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePass" class="btn_eye">{{ hidePass ? 'visibility_off' : 'visibility' }}</mat-icon>
                            <!-- </button> -->
                        </mat-form-field>
                        <!-- <div *ngIf="psw.invalid && (psw.dirty || psw.touched)" class="alert alert-danger">
                            <div *ngIf="psw.errors.required">
                                Pass is required.
                            </div>
                        </div> -->
                        <!-- <div class="form__group field">
                            <input formControlName="recordarme" type="checkbox" name="remember" id="remember">
                            <label for="remember">Recordar Usuario</label>
                        </div> -->
                        <div class="cont-btn" *ngIf="true">
                            <button type="submit" class="btn" [disabled]="!loginForm.valid" (click)="send()">Iniciar
                                Sesión</button>
                        </div>
                    </form>
                </div>
                <div class="react" *ngIf="mostraReact">
                    <P>
                        La tienda se encuentra inactiva
                        <button class="btn" (click)="activarTienda()">Activar</button>
                    </P>
                    <!-- <p>¿Desea enviar codigo de seguridad? <button *ngIf="!mostraCont" class="btn" (click)="preEnvioClave()">Enviar</button>
                        <span class="time" *ngIf="mostraCont">Reenviar en
                            {{timeLeft}}</span>
                    </p>
                    <div class="inp" *ngIf="inpCode">
                        <mat-form-field appearance="outline">
                            <mat-label>Codigo</mat-label>
                            <input class="code" type="number" [(ngModel)]="codigo" matInput placeholder="Codigo" autocomplete="off" #codeReac>
                        </mat-form-field>
                        <div>
                            <button class="btn2" (click)="codeReac.value=''">Borrar</button>
                            <button class="btn3" (click)="verificaClave(codeReac.value)">Aceptar</button>
                        </div>
                    </div> -->
                </div>
                <div class="forgot" *ngIf="!forg && !mostraReact">
                    <span (click)="olvideContrasenna()">¿Olvidaste tu contraseña?</span>
                </div>
                <div class="formul" *ngIf="forg">
                    <form [formGroup]="recoverForm" (ngSubmit)="sendRecover()">
                        <mat-form-field appearance="outline">
                            <mat-label>Usuario</mat-label>
                            <input matInput class="inputs" type="input" name="user2" id="user2" formControlName="usuario" autocomplete="off" required>
                            <!-- <mat-hint>Hint</mat-hint> -->
                        </mat-form-field>
                        <!-- <div class="inp-user">
                            <input class="inputs" type="input" name="user2" id="user2" formControlName="usuario" required />
                            <label for="user2" alt="Usuario" placeholder="Usuario"></label>
                        </div> -->
                        <!-- <div *ngIf="usuario.invalid && (usuario.dirty || usuario.touched)" class="alert alert-danger">
                                            <div *ngIf="usuario.errors.required">
                                                User is required.
                                            </div>
                                        </div> -->
                        <div class="cont-btn">
                            <button type="submit" class="btn" [disabled]="!recoverForm.valid">Recuperar</button>
                        </div>
                    </form>
                </div>
                <div class="foot">
                    <p>
                        ¿No tienes una cuenta? <a (click)="clickM()">Regístrate</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="col right navegador">
            <img class="rectangulo" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Rectangulo-new.png" alt="">
            <img class="logimg" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Login-new.png" alt="">
        </div>
    </div>
</div>